export default __webpack_public_path__ + "images/ecd1a46f73c845a2340c76d13d34cc36-disaster_relief_small.webp";